import { keepPreviousData, useQuery } from "@tanstack/react-query";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { companyQueryKeys } from "@/company/data/companyQueryKeys";
import {
  CompaniesCountBody,
  CompaniesSearchBody,
} from "@reflag/shared/companyAPI";

export function useCompaniesData(
  body?: Omit<CompaniesSearchBody, "envId">,
  enabled = true,
) {
  const { appId, envId } = useEnvironment();
  return useQuery({
    queryKey: companyQueryKeys.list(appId, envId, body),
    queryFn: () =>
      api
        .post<`/apps/:appId/companies/search`>(
          `/apps/${appId}/companies/search`,
          {
            ...body,
          },
          {
            params: {
              envId: envId!,
            },
          },
        )
        .then((res) => res.data),
    enabled: !!appId && !!envId && enabled,
    placeholderData: keepPreviousData,
  });
}

export function useCompaniesCount(
  body: Omit<CompaniesCountBody, "envId"> = {},
  enabled = true,
) {
  const { appId, envId } = useEnvironment();
  return useQuery({
    queryKey: companyQueryKeys.count(appId, envId, body),
    queryFn: () =>
      api
        .post<`/apps/:appId/companies/search/count`>(
          `/apps/${appId}/companies/search/count`,
          { ...body },
          {
            params: {
              envId: envId!,
            },
          },
        )
        .then((res) => res.data),
    enabled: !!appId && !!envId && enabled,
    placeholderData: keepPreviousData,
  });
}
